import type {
  EstimateParticipationSubsidiesData,
  PrestationParticipationsFilters,
  SubsidisingRuleQuery,
} from '@cpce/shared';
import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['prestations']);

export const prestationsQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
  account: (id: number) => builder('account', id),
  infinite: (params: object) => builder('infinite', params),
  participations: (filters: PrestationParticipationsFilters) => builder('participations', filters),
  participation: (id: number) => builder('participation', id),
  participationAttachments: (id: number) => builder('participation', id, 'attachments'),
  subsidyRules: builder('subsidy-rules'),
  prestationSubsidyRules: (id: number) => builder('subsidy-rules', id),
  subsidyProducts: builder('subsidy-products'),
  subsidisingRule: (query: SubsidisingRuleQuery) => builder('subsidising-rule', query),
  subsidyEstimates: (data: EstimateParticipationSubsidiesData) =>
    builder('subsidy-estimates', data),
};
